import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxMaterialTimepickerModule, NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { first } from 'rxjs';
import { DEFAULT_SCHEDULE, Schedule } from 'src/app/interfaces/api/project';

@Component({
  imports: [
    CommonModule,
    MatIconModule,
    MatInput,
    MatSlideToggleModule,
    NgxMaterialTimepickerModule,
    MatButtonToggleModule,
    TranslateModule
  ],
  selector: 'app-schedule',
  styleUrl: './schedule.component.scss',
  templateUrl: './schedule.component.html',
  standalone: true
})

export class ScheduleComponent implements OnInit {
  @Input() schedule?: Schedule;
  @Output() scheduleChange = new EventEmitter<Schedule>();

  private translate: TranslateService = inject(TranslateService);
  _schedule!: Schedule;

  days = [
    { name: 'Monday', value: 'mon' },
    { name: 'Tuesday', value: 'tue' },
    { name: 'Wednesday', value: 'wed' },
    { name: 'Thursday', value: 'thu' },
    { name: 'Friday', value: 'fri' },
    { name: 'Saturday', value: 'sat' },
    { name: 'Sunday', value: 'sun' },
  ];

  theme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--content-background-color)',
      buttonColor: 'var(--text-color)'
    },
    dial: {
      dialBackgroundColor: 'var(--background-color)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--background-color)',
      clockHandColor: 'var(--primary-color)',
      clockFaceTimeInactiveColor: 'var(--text-color)'
    }
  };

  ngOnInit(): void {
    this.setDays();
    this._schedule = structuredClone(this.schedule ?? DEFAULT_SCHEDULE);
  }

  setSchedule(event: any, day: string, type: string, index: number = 0): void {
    if (type === 'startTime') {
      this._schedule[day as keyof Schedule]!.times[index]![0] = event;
    } else if (type === 'endTime') {
      this._schedule[day as keyof Schedule]!.times[index]![1] = event;
    } else if (type === 'toggle') {
      this._schedule[day as keyof Schedule].enable = event.checked;
    }

    this.scheduleChange.emit(this._schedule);
  }

  addRange(day: string): void {
    const daySchedule = this._schedule[day as keyof Schedule];
    if (daySchedule.times.length < 3) {
      let prevTime = daySchedule.times[daySchedule.times.length - 1] || ['_', '23:59'];
      daySchedule.times.push([prevTime[1], '23:59']);
      this.scheduleChange.emit(this._schedule);
    }
  }

  deleteRange(day: string): void {
    const daySchedule = this._schedule[day as keyof Schedule];
    if (daySchedule.times.length > 1) {
      daySchedule.times.pop();
      this.scheduleChange.emit(this._schedule);
    }
  }

  setDays() {
    this.translate.get('date.monday').pipe(first()).subscribe(() => {
      this.days = [
        { name: this.translate.instant('date.monday'), value: 'mon' },
        { name: this.translate.instant('date.tuesday'), value: 'tue' },
        { name: this.translate.instant('date.wednesday'), value: 'wed' },
        { name: this.translate.instant('date.thursday'), value: 'thu' },
        { name: this.translate.instant('date.friday'), value: 'fri' },
        { name: this.translate.instant('date.saturday'), value: 'sat' },
        { name: this.translate.instant('date.sunday'), value: 'sun' },
      ]
    });
  }
}
